import type { FC } from 'react';
import cn from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import ExcerptRenderer from '@wix/da-shared-react/pkg/TextRenderer/ExcerptRenderer';

import s from './DeviationTextExcerpt.scss';

interface Props {
  deviation: PapiDeviation;
  noWrap?: boolean;
  className?: string;
}

const DeviationTextExcerpt: FC<Props> = ({
  deviation,
  noWrap,
  className,
}) => {
  return (
    <div className={cn(s['root'], noWrap && s['no-wrap'], className)}>
      <ExcerptRenderer
        className={s['excerpt']}
        textContent={deviation.textContent}
      />
    </div>
  );
};
DeviationTextExcerpt.displayName = 'DeviationTextExcerpt';

export default DeviationTextExcerpt;
